import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { StatementCardWithModal, StatementData } from '../StatementCards';

interface StatementDetailModalProps {
    visible: boolean;
    onClose: () => void;
    statement: (StatementData & { id: string | number }) | null;
    categoryName: string;
    isAdmin?: boolean;
    theme?: 'dark' | 'light';
}

const StatementDetailModal: React.FC<StatementDetailModalProps> = ({
    visible,
    onClose,
    statement,
    categoryName,
    isAdmin = false,
    theme = 'light'
}) => {
    const intl = useIntl();

    if (!statement) return null;

    // Convert id to string if it's a number for compatibility
    const statementData: StatementData = {
        ...statement,
        id: String(statement.id)
    };

    const isDark = theme === 'dark';

    return (
        <Modal
            title={
                <span style={{ color: isDark ? '#f1f5f9' : '#1f2937' }}>
                    {intl.formatMessage({ id: 'statements.detail.modalTitle' }, { categoryName })}
                </span>
            }
            open={visible}
            onCancel={onClose}
            footer={null}
            width={700}
            centered
            closeIcon={<CloseOutlined style={{ color: isDark ? '#94a3b8' : undefined }} />}
            styles={{
                content: {
                    backgroundColor: isDark ? '#1a1f2e' : '#ffffff',
                    color: isDark ? '#ffffff' : '#1f2937',
                },
                header: {
                    backgroundColor: isDark ? '#1a1f2e' : '#ffffff',
                    color: isDark ? '#ffffff' : '#1f2937',
                    borderBottom: isDark ? '1px solid rgba(100, 116, 139, 0.3)' : '1px solid #e5e7eb',
                },
                body: {
                    backgroundColor: isDark ? '#1a1f2e' : '#ffffff',
                }
            }}
            className={isDark ? 'dark-modal' : ''}
        >
            <div style={{ marginBottom: 0 }}>
                <StatementCardWithModal
                    statement={statementData}
                    isAdmin={isAdmin}
                    theme={theme}
                />
            </div>
        </Modal>
    );
};

export default StatementDetailModal;